export default function px2rem() {
  let rootHtml, deviceWidth, deviceHeight
  if (isMobile()) {
    rootHtml = document.documentElement
    deviceWidth = rootHtml.clientWidth
    rootHtml.style.fontSize = deviceWidth / (750 / 100) + 'px'
  } else {
    rootHtml = document.documentElement
    deviceHeight = rootHtml.clientHeight
    rootHtml.style.fontSize = deviceHeight / (1650 / 100) + 'px'
  }
}

function isMobile() { //判断pc和移动
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Windows CE", "BlackBerry", "Harmony");
  var flag = false;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = true; break; }
  }
  let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
  if (!flag && isiPad) {
    flag = true
  }
  return flag;
}